import {
    getAxios
} from './axios'

export function getRegions(country) {
    let axios = getAxios();

    return axios.get(
        '/regions/?country=' + encodeURIComponent(country)
    );
}


// WEBPACK FOOTER //
// ./src/backend-helpers/misc.js